import { render, staticRenderFns } from "./departcentermentuser.vue?vue&type=template&id=5475fc7a&"
import script from "./departcentermentuser.vue?vue&type=script&lang=js&"
export * from "./departcentermentuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports